
































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import SelectRole from 'components/presenter/item/team/SelectRole.vue'
import api from 'src/assets/api/gql'
import ItemShareCreate from 'src/graphql/item_share/ItemShareCreate.gql'
import ItemShareDelete from 'src/graphql/item_share/ItemShareDelete.gql'
import { Item, ItemShare, ItemShareRole } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar,
    SelectRole
  }
})
export default class ItemTeamListItem extends Vue {
  loading = false

  @Prop()
  readonly item!: Item

  @Prop()
  readonly member!: ItemShare

  @Ref()
  readonly dialog!: SelectRole

  get path () {
    const ancesstors = this.member.itemByPath?.ancesstors || []
    return '/' + [...ancesstors, this.member.itemByPath?.name].join('/')
  }

  async select (role: ItemShareRole) {
    this.loading = true
    if (role) {
      await this.setRole(role)
    } else {
      await this.deleteRole(role)
    }
    this.loading = false
  }

  async setRole (role: ItemShareRole) {
    const { data: { createItemShare } } = await api.mutate({
      query: ItemShareCreate,
      variables: {
        input: {
          path: this.item.path,
          personId: this.member.personId,
          role
        }
      }
    })
    if (createItemShare) {
      this.$emit('set', createItemShare.itemShare)
    }
  }

  async deleteRole (role: ItemShareRole) {
    await api.mutate({
      query: ItemShareDelete,
      variables: {
        input: {
          path: this.item.path,
          personId: this.member.personId
        }
      }
    })
    this.$emit('remove')
  }
}
